export default __webpack_public_path__ + "static/gym_1-0564fcc063a90a20c3bf66cee8ad17a6.png";